import React, { useState } from 'react';
import Intl from '@fx-ui/intl';
import { Button, Input, Message, Result } from '@fx-ui/fine-design';
import ErrorImg from '~/assets/error/ice-cream-error.png';
import { copyToClipboard } from '~/utils';

interface IErrorBoundaryFallbackProps {
    errorTag?: string;
    onRefresh?: () => React.ReactElement;
}

const ErrorBoundaryFallback: React.FC<IErrorBoundaryFallbackProps> = ({ errorTag, onRefresh }) => {
    const [refresh, setRefresh] = useState(false);

    if (refresh && onRefresh) {
        return onRefresh();
    }

    const renderErrorInfo = () => {
        if (window.jdy_config?.corp_sentry?.pc?.dsn) {
            const info = `uuid:${errorTag}`;
            return (
                <Input
                    style={{ width: 500, marginBottom: 8 }}
                    value={info}
                    disabled
                    afterAddon={
                        <Button
                            type="negative"
                            onClick={() => {
                                copyToClipboard(info, () =>
                                    Message.add({
                                        messageType: 'toast',
                                        type: 'success',
                                        message: Intl.get('copy.success')
                                    })
                                );
                            }}
                        >
                            {Intl.get('copy')}
                        </Button>
                    }
                />
            );
        }
    };

    return (
        <Result
            image={ErrorImg}
            imageStyle={{ marginTop: 100 }}
            title={Intl.get('error.boundary.title')}
            description={Intl.get('error.boundary.description')}
        >
            <div
                style={{
                    margin: '10px',
                    display: 'flex',
                    alignItems: 'center',
                    flexDirection: 'column'
                }}
            >
                {renderErrorInfo()}
            </div>
            <Button type="primary" onClick={() => setRefresh(true)}>
                {Intl.get('refresh')}
            </Button>
        </Result>
    );
};

export default ErrorBoundaryFallback;
